import { PhoneNumberUtil } from "google-libphonenumber";
import { handleError } from "./errorHandler";
import { EMAIL_REG_EXP, MX_PHONE, NAME_REG_EXP } from './consts';
import { emailValidation, phoneValidation } from './validation';
import { selectValidMessagesPassword, isPasswordValid } from "./validate_password";
import { validateBirthday }from "./validate_birthday";
import { trackGtagEvent } from "./utils.js";

const signUpForm = document.getElementById("signup-form");
const inputsArr = [...signUpForm.querySelectorAll('.sign-up__input')];
const phoneNumberInstance = PhoneNumberUtil.getInstance();

const addErrors = (errorContainer) => {
	errorContainer?.classList.add('show');
}

const getEmailError = (email) => {
	if (email.length < 7) {
		return 'Mínimo 7 caracteres';
	}
	if (email.length > 50) {
		return 'Máximo 50 caracteres';
	}
	if (!email.match(EMAIL_REG_EXP)) {
		return 'Tu correo electrónico es incorrecto';
	}
	return '';
};

const validatePhoneNumber = (phoneNumber) => {
	if (phoneNumber.length >= 6) {
		try {
			const phoneNumberWithCode = phoneNumberInstance
				.parseAndKeepRawInput(`+52${phoneNumber}`, '+52');

				if (
					!phoneNumber.match(MX_PHONE) ||
					!phoneNumberInstance.isValidNumber(phoneNumberWithCode)
				) {
					return 'El número de teléfono es incorrecto';
				}
			} catch (e) {
				return 'El número de teléfono es incorrecto';
			}
	} else {
		return 'El número de teléfono es incorrecto';
	}
	return '';
}

const validateFirstStep = () => {
	const emailInput = document.getElementById('signup-email');
	const passwordInput = document.getElementById('signup-password');
	const emailErrorContainer = signUpForm.querySelector(".error__message.signup-email");
	const phoneInput = document.getElementById('signup-phone');
	const phoneErrorContainer = signUpForm.querySelector(".error__message.signup-phone");
	const hintPasswordElements = signUpForm.querySelectorAll('.signup-hint-password');

	addErrors(emailErrorContainer);
	addErrors(phoneErrorContainer);

	inputsArr.forEach((input) => {
		input.addEventListener('input', (e) => {
			const startInputTime = sessionStorage.getItem("startInputTime"); // In every session we will have new time

			if (!startInputTime) {
				sessionStorage.setItem("startInputTime", Date.now().toString());
			}

			const attr = input.getAttribute('data-validation');
			
			if (attr === 'email') {
				handleError(getEmailError(e.target.value), emailErrorContainer);
			}

			if (attr === 'password') {
				selectValidMessagesPassword(e.target.value, hintPasswordElements)
			}

			if (attr === 'phone') {
				handleError(validatePhoneNumber(e.target.value), phoneErrorContainer);
			}
		});
	});

	const checkEmail = async (field) => {
		const { value } = field.target;
		let isError;

		if (emailErrorContainer.innerHTML === '' && value.length > 0) {
			isError = await emailValidation(value.trim(), emailErrorContainer);
		}

		if (getEmailError(value) || isError) {
			trackGtagEvent('sign_up_form_email_invalid');
		}
		else {
			trackGtagEvent('sign_up_form_email_validated');
		}
	};

	const checkPhone = async (field) => {
		const { value } = field.target;
		let isError;

		if (phoneErrorContainer.innerHTML === '' && value.length > 0) {
			isError = await phoneValidation(value, phoneErrorContainer);
		}

		if (validatePhoneNumber(value) || isError) {
			trackGtagEvent('sign_up_form_phone_number_invalid');
		}
		else {
			trackGtagEvent('sign_up_form_phone_number_validated');
		}
	};

	const checkPassword = (field) => {
		const { value } = field.target;
		
		if (isPasswordValid(value)) {
			trackGtagEvent('sign_up_form_password_validated');
    	}
		else {
			trackGtagEvent('sign_up_form_password_invalid');
		}
  	};

	const onPhoneKeyPress = (e) => {
		const charStr = e.key.toString();
		if (!charStr.match(/^[0-9-]*$/)) {
			e.preventDefault()
		}
	};

	return ({
		addEventListeners: () => {
			console.log("addEventListeners");
			emailInput.addEventListener('blur', checkEmail);
			passwordInput.addEventListener('blur', checkPassword);
			phoneInput.addEventListener('blur', checkPhone);
			phoneInput.addEventListener('keypress', onPhoneKeyPress);
		},
		removeEventListeners: () => {
			console.log("removeEventListener");
			emailInput.removeEventListener('blur', checkEmail);
			passwordInput.removeEventListener('blur', checkPassword);
			phoneInput.removeEventListener('blur', checkPhone);
			phoneInput.removeEventListener('keypress', onPhoneKeyPress);
		},
	});
}

const getTextFieldError = (value) => {
	if (value.length < 2) {
		return 'Mínimo 2 caracteres';
	}
	if (value.length > 50) {
		return 'Máximo 50 caracteres';
	}
	if (!value.match(NAME_REG_EXP)) {
		return 'Por favor, introduzca sólo el texto en latín o en español';
	}
	return '';
};

const getCouponError = (value) => {
	if (value.length > 20) {
		return 'Máximo 20 caracteres'
	}
	return '';
};

const validateTextField = (value, errorContainer) => {
	handleError(getTextFieldError(value), errorContainer);
}

const validateSecondStep = () => {
	const nameErrorContainer = signUpForm.querySelector(".error__message.signup-first-name");
	const surnameErrorContainer = signUpForm.querySelector(".error__message.signup-last-name");
	const couponErrorContainer = signUpForm.querySelector(".error__message.signup-coupon-code");
	const nameInput = signUpForm.querySelector("#signup-name");
	const surnameInput = signUpForm.querySelector("#signup-surname");
	const couponCodeInput = signUpForm.querySelector("#couponCode");
	const dayInput = signUpForm.querySelector("#screen-day");
	const dayErrorContainer = signUpForm.querySelector(".error-message.day-error");
	const monthInput = signUpForm.querySelector("#screen-month");
	const monthErrorContainer = signUpForm.querySelector(".error-message.month-error");
	const yearInput = signUpForm.querySelector("#screen-year");
	const yearErrorContainer = signUpForm.querySelector(".error-message.year-error");
	const dateErrorContainer = signUpForm.querySelector(".error__message.signup-dob");
	const selectHeadersArr = [...signUpForm.querySelectorAll('.signup__birthdate__row')];
	const selectListsArr = [...signUpForm.querySelectorAll('.select__list.js-select-list')];

	inputsArr.forEach((input) => {
		input.addEventListener('input',  (e) => {
			const attr = input.getAttribute('data-validation');
			
			if (attr === 'name') {
				validateTextField(e.target.value, nameErrorContainer);
			}

			if (attr === 'surname') {
				validateTextField(e.target.value, surnameErrorContainer);
			}

			if (attr === 'couponCode') {
				handleError(getCouponError(e.target.value), couponErrorContainer);
			}
		});
	});

	// need for revalidation if the user returned from the first step
	validateBirthday(
		dayInput.dataset.value, 
		monthInput.dataset.value, 
		yearInput.dataset.value,
		dayErrorContainer,
		monthErrorContainer,
		yearErrorContainer,
		dateErrorContainer,
	);
	
	[...selectHeadersArr, ...selectListsArr].forEach((item) => {
		item.addEventListener('click', () => {	
			const day = dayInput.dataset.value;
			const month = monthInput.dataset.value;
			const year = yearInput.dataset.value;
			validateBirthday(
				day,
				month,
				year,
				dayErrorContainer,
				monthErrorContainer,
				yearErrorContainer,
				dateErrorContainer,
			);
		})
	});

	const validateName = (e) => {
		const value = e.target.value.trim();

		if (getTextFieldError(value)) {
			trackGtagEvent('sign_up_form_name_invalid');
		} else {
			trackGtagEvent('sign_up_form_name_validated');
		}

		validateTextField(value, nameErrorContainer);
	};

	const validateSurname = (e) => {
		const value = e.target.value.trim();

		if (getTextFieldError(value)) {
			trackGtagEvent('sign_up_form_surname_invalid');
		} else {
			trackGtagEvent('sign_up_form_surname_validated');
		}

		validateTextField(value, surnameErrorContainer);
	};

	const validateDateOfBirth = () => {
		const day = dayInput.dataset.value;
		const month = monthInput.dataset.value;
		const year = yearInput.dataset.value;	

		const hasErrors = validateBirthday(
			day,
			month,
			year,
			dayErrorContainer,
			monthErrorContainer,
			yearErrorContainer,
			dateErrorContainer,
		);

		if (hasErrors) {
			trackGtagEvent('sign_up_form_dob_invalid');
		} else {
			trackGtagEvent('sign_up_form_dob_validated');
		}
	};

	const validateCouponCode = (e) => {
		const value = e.target.value.trim();
		const errorMessage = getCouponError(value);

		if (!errorMessage) {
			trackGtagEvent('sign_up_form_coupon_validated');
		} else {
			trackGtagEvent('sign_up_form_coupon_invalid');
		}
	};

	return ({
		addEventListeners: () => {
			console.log("addEventListeners");
			nameInput.addEventListener('blur', validateName);
			surnameInput.addEventListener('blur', validateSurname);
			[...selectHeadersArr, ...selectListsArr].forEach((el) => {
				el.addEventListener('click', validateDateOfBirth);
			});
			couponCodeInput.addEventListener('blur', validateCouponCode);
		},
		removeEventListeners: () => {
			console.log("removeEventListener");
			nameInput.removeEventListener('blur', validateName);
			surnameInput.removeEventListener('blur', validateSurname);
			[...selectHeadersArr, ...selectListsArr].forEach((el) => {
				el.removeEventListener('click', validateDateOfBirth);
			});
			couponCodeInput.addEventListener('blur', validateCouponCode);
		},
	});
}

export { addErrors, validateFirstStep, validateSecondStep };
